import { css } from 'linaria';

export const mobileFixedPanel = css`
  display: none;

  @media (--only-mobile) {
    display: block;
  }
`;

export const mobilePanelModal = css`
  && {
    background-color: var(--background-accent);
  }
`;

export const closeIcon = css`
  && {
    position: absolute;
    top: 22px;
    right: 22px;
    z-index: 10;
  }
`;

export const mobilePanelIcon = css`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
`;

export const mobilePanelModalContent = css`
  && {
    padding-top: 24px;
    padding-bottom: 24px;
  }
`;

export const mobilePanelDescription = css`
  margin-bottom: 24px;
`;

export const mobilePanelModalActions = css`
  width: 100%;

  a {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
